import React from "react";
import styled from "@emotion/styled";

import { Chip as MuiChip } from "@mui/material";

const Chip = styled(MuiChip)<{ bgcolour: string }>`
  height: 25px;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 10px;
  background-color: ${(props) => props.bgcolour};
  color: ${(props) => props.theme.palette.common.white};
`;

interface Props {
  label: string;
  color: string;
}

function BookmarkGroupChip(prop: Props) {
  const { label, color } = prop;

  return <Chip label={label} bgcolour={color} />;
}

export default BookmarkGroupChip;
